import { EnumPaymentGmoPgStatus } from '../../types'
import { find, isNil, maxBy } from 'lodash/fp'

export const pickMostPriorirtyLog = (
  payments: {
    effectiveDate: string
    amount: number
    status: EnumPaymentGmoPgStatus
  }[]
):
  | {
      effectiveDate: string
      amount: number
      status: EnumPaymentGmoPgStatus
    }
  | undefined => {
  const success = find(
    (payment: {
      effectiveDate: string
      amount: number
      status: EnumPaymentGmoPgStatus
    }) => {
      return payment.status === EnumPaymentGmoPgStatus.Processed
    }
  )(payments)
  if (!isNil(success)) return success
  const processing = find(
    (payment: {
      effectiveDate: string
      amount: number
      status: EnumPaymentGmoPgStatus
    }) => {
      return payment.status === EnumPaymentGmoPgStatus.Processing
    }
  )(payments)
  if (!isNil(processing)) return processing
  const error = find(
    (payment: {
      effectiveDate: string
      amount: number
      status: EnumPaymentGmoPgStatus
    }) => {
      return payment.status === EnumPaymentGmoPgStatus.Error
    }
  )(payments)
  if (!isNil(error)) return error
  return maxBy((payment: {
    effectiveDate: string
    amount: number
    status: EnumPaymentGmoPgStatus
  }) => payment.effectiveDate)(payments)
}
